// extracted by mini-css-extract-plugin
export default {"serviceItem":"ServiceParams_serviceItem__AyUBu","id":"ServiceParams_id__Pvs1K"};